//! Трансформация для фильтров
export const transformDataForFilters = (items: any) => {
  if (!Array.isArray(items)) return [];
  return items.map((item) => ({
    ID: item.id,
    Title: item.Title || item.title,
  }));
};

//! трансформация данных для фильтров
export const transformDataForFiltersInCode = (items: any) => {
  if (!Array.isArray(items)) return [];
  return items.map((item) => ({
    ID: item.id,
    Title: item.Title || item.title,
    Code: item.Code || item.code || item.Title || item.title,
  }));
};

export const transformDataForFiltersFactory = (items: any) => {
  if (!Array.isArray(items)) return [];
  return items.map((item) => ({
    ID: item.id,
    Title: item.Title || item.title,
    VPOgroup: item.group
  }));
};

export const transformDataForFiltersRequirements = (items: any) => {
  if (!Array.isArray(items)) return [];
  return items.map((item) => ({
    ID: item.id,
    Title: item.Title || item.title,
    MaturityLevel: item.maturityLevel
  }));
};